module.exports = __webpack_public_path__ + "img/icon_5.902b685b.png";